export default __webpack_public_path__ + "static/media/Apple_download_icon.d7f09fc1.png";